'use strict';
import angular from 'angular';

angular.module('vendors.services', [])
    .service('VendorsService', VendorsService)
    .service('VendorFactory', VendorFactory);

VendorsService.$inject = ['VendorFactory', '$q'];

function VendorsService(VendorFactory, $q) {
    var service = {};
    
    service.createNewVendor = function(formObj) {
        var deferred = $q.defer();
        VendorFactory.create().save(formObj).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error creating new vendor");
            deferred.reject();
        });

        return deferred.promise;
    }

    service.vendorLogin = function(formObj) {
        var deferred = $q.defer();
        VendorFactory.login().save(formObj).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error vendor login");
            deferred.reject();
        });

        return deferred.promise;
    }

    return service;
}

VendorFactory.$inject = ['$resource', 'AppConfig'];

function VendorFactory($resource, AppConfig) {
    var factory = {};

    factory.create = function() {
        return $resource(AppConfig.MAGE_URL + 'session/signupVendor', null, {
            'save': { method: 'POST' }
        });
    };

    factory.login = function() {
        return $resource(AppConfig.MAGE_URL + 'session/login', null, {
            'save': { method: 'POST' }
        });
    };

    return factory;
}